import type { CSSProperties } from "react";
import type { AdventureContent } from "../types/adventure";

interface SummaryScreenProps {
  adventure: AdventureContent;
  images: Record<string, string | null>;
  onRestart: () => void;
}

export function SummaryScreen({ adventure, images, onRestart }: SummaryScreenProps) {
  const endingUrl = images.ending ?? images.goal;

  return (
    <section
      className="act-summary jari-card"
      style={adventure.theme as CSSProperties}
    >
      <h2>Avontuur voltooid!</h2>

      <figure className="act-summary__figure">
        {endingUrl ? (
          <img
            className="act-summary__image"
            src={endingUrl}
            alt={`Je hebt je doel bereikt: ${adventure.goal.name}`}
          />
        ) : (
          <div className="act-summary__image-placeholder" aria-hidden>
            <span className="act-summary__goal-icon">{adventure.goal.icon}</span>
            <span className="act-summary__goal-name">{adventure.goal.name}</span>
          </div>
        )}
        <figcaption className="act-summary__caption">
          {adventure.goal.icon} {adventure.goal.name}
        </figcaption>
      </figure>

      <p className="act-summary__ending">{adventure.ending}</p>

      <div className="act-summary__actions">
        <button type="button" className="jari-btn jari-btn--primary" onClick={onRestart}>
          Nieuw avontuur
        </button>
      </div>
    </section>
  );
}
